(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('sideMenuV2', ["path", "routeHelper", "$route", "feature", "sideMenuManager", "$timeout", "modulesManager", "$cookies", "autologinHelper", "$rootScope", "$location", function (path, routeHelper, $route, feature, sideMenuManager, $timeout, modulesManager, $cookies, autologinHelper, $rootScope, $location) {
        var root = path('gui-v2').directive('side-menu-v2');
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('side-menu-v2').template(),
            scope: {},
            link: function ($scope, element, attrs) {
                $scope.isDarkTheme = feature.isDarkTheme;
                $scope.minimizable = !feature.checkpointTheme;
                $scope.autologinCP = autologinHelper.enabled() || $cookies.get('autologinCP');
                $scope.showLogo = function () {
                    return !sideMenuManager.v2FullTop();
                };
                $scope.showSearch = function () {
                    return !sideMenuManager.v2FullTop();
                };
                $scope.showUserMenu = function () {
                    return !sideMenuManager.v2FullTop();
                };
                if ($scope.minimizable) {
                    if (localStorage.getItem('sideMenuState') == 'minimized') {
                        $scope.minimized = true;
                    } else if (localStorage.getItem('sideMenuState') == 'expanded') {
                        $scope.minimized = false;
                    }
                }
                $scope.sideMenuManager = sideMenuManager;
                $scope.logoHref = routeHelper.pathToHref('/');
                $scope.menuVisible = function () {
                    return $route.current && !$route.current.fullscreen;
                };
                $scope.toggleMinimized = function () {
                    $scope.onMinimize = true;
                    $timeout(function () {
                        $scope.minimized = !$scope.minimized;
                        var storageState = $scope.minimized ? 'minimized' : 'expanded';
                        localStorage.setItem('sideMenuState', storageState);
                        $scope.onMinimize = false;
                        $scope.showLicenseWarning();
                    }, 200);
                };
                $scope.poweredByLogo = root.imgRel('logo-white.svg');
                feature.init(true, true).then(function () {
                    if (feature.checkpointTheme) {
                        $scope.logo = root.imgRel('checkpoint-logo.png');
                    } else if (feature.lastlineTheme) {
                        $scope.tryCustomLogo = true;
                        $scope.logo = root.imgRel('lastline-logo-white.png');
                    } else if (feature.sonicwallTheme) {
                        $scope.tryCustomLogo = true;
                        $scope.logo = root.imgRel('sonicwall-logo-w.png');
                    } else {
                        $scope.tryCustomLogo = true;
                        $scope.logo = root.imgRel('logo-white.svg');
                        if (sideMenuManager.isManagedService()) {
                            $scope.displayPremiumLabel = true;
                            $scope.logo = root.imgRel('premium-logo.png');
                        }
                    }
                });
                $scope.showLicenseWarning = function () {
                    return {
                        label1: sideMenuManager.limitedLicense() && $scope.minimized && !feature.checkpointTheme,
                        label2: sideMenuManager.limitedLicense() && !$scope.minimized && !feature.checkpointTheme,
                        label3: feature.checkpointTheme
                    };
                };
                $scope.showTopWarningLabels = false;
                function genTopWarningLabels() {
                    if (!$rootScope.gotTrialExpirationDays) {
                        $timeout(genTopWarningLabels, 2000);
                    }
                    $scope.licenseTip = undefined;
                    $scope.showTopWarningLabels = true;
                    if ($scope.autologinCP && feature.checkpointTheme && sideMenuManager.limitedLicense() && sideMenuManager.trialMessageLabel() && sideMenuManager.trialMessageLabel() !== 'Expired') {
                        $scope.topWarningLabels = 'Limited trial';
                        $scope.licenseTip = {
                            content: { text: sideMenuManager.trialMessage() + '<br/>Click to assign user licenses' },
                            position: {
                                at: 'right center',
                                my: 'left top'
                            },
                            style: { classes: 'qtip-standard' }
                        };
                    } else if ($scope.autologinCP && feature.checkpointTheme && (sideMenuManager.trialMessageLabel() === 'Expired' || !sideMenuManager.limitedLicense() && sideMenuManager.trialMessageLabel())) {
                        $scope.topWarningLabels = sideMenuManager.trialMessageLabel();
                        $scope.licenseTip = {
                            content: { text: sideMenuManager.trialMessage() },
                            position: {
                                at: 'right center',
                                my: 'left top'
                            },
                            style: { classes: 'qtip-standard' }
                        };
                    } else if (sideMenuManager.limitedLicense()) {
                        $scope.topWarningLabels = 'Limited license';
                        $scope.licenseTip = {
                            content: { text: 'Click to assign user licenses' },
                            position: {
                                at: 'right center',
                                my: 'left top'
                            },
                            style: { classes: 'qtip-standard' }
                        };
                    } else {
                        $scope.showTopWarningLabels = false;
                    }
                    $scope.goToLicenseConfig = function () {
                        if ($scope.autologinCP && feature.checkpointTheme && (!sideMenuManager.limitedLicense() && sideMenuManager.trialMessageLabel() || sideMenuManager.limitedLicense() && sideMenuManager.trialMessageLabel() === 'Expired')) {
                            return;
                        }
                        routeHelper.redirectTo('license-configuration', { module: modulesManager.currentModule() });
                    };
                }
                genTopWarningLabels();
            }
        };
    }]);
}());